<template>
  <div class="hzc-price-index">
    <!-- <TwoPageHeader :typeTitle="'正文'"></TwoPageHeader> -->
    <div class="back">当前位置：<span @click="back">焦炭</span> > 全国产量 > 正文</div>
    <DetailTitle :title="'全国产量'"></DetailTitle>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        :max-height="400"
        style="width: 100%">
      <el-table-column
          align="center"
          prop="druidParamName"
          width="300"
          label="指标名称">
      </el-table-column>
      <el-table-column align="center" v-for="(item,index) in typeList" :key="index">
        <template slot="header">
          <span>{{ item }}</span>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row[`price${index + 1}`] }}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="floatPrice"
          label="涨跌幅">
        <template slot-scope="scope">
          <FloatPrice :floatPrice="scope.row['floatPrice']"/>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="address"
          label="单位">
        <template>
          <span>万吨</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="echarts">
      <div id="myChart" style="width: 1100px;height:340px;"></div>
    </div>
  </div>
</template>

<script>
import TwoPageHeader from '@/components/common/twoPageHeader'
import DetailTitle from '@/components/common/detatilTitle'
import {
  detailsCokeYield,mapData
} from '@/api/coke'

export default {
  name: "priceIndex",
  components: {
    TwoPageHeader,
    DetailTitle
  },
  data() {
    return {
      typeList: [],
      tableData: [],
      name:""
    }
  },
created() {
detailsCokeYield({dataType:3,dictDataType:'issue_coke_yield',endTime:'2021-10-25'}).then((res)=>{
  this.tableData = res.data.data
  this.typeList = res.data.timeList
  this.name = this.tableData[0]['druidParamName'];
})
  },
  methods: {
    /**
     * 回退
     */
    back() {
      this.$router.push('/coke')
    },
    /**
     * 选择地图
     */
    chooseEchars(row) {
      console.log(row)
    },
    /**
     * 加载地图
     */
    drawChart() {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let option = {
        title: {
          text: "产量"
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ["2019", '2020', '2021']
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "2019",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#F26D77' //改变折线颜色
            },
          },
          {
            name: "2020",
            type: "line",
            data: [10, 30, 58, 27, 29, 5],
            lineStyle: {
              color: '#ccc' //改变折线颜色
            },
          },
          {
            name: "2021",
            type: "line",
            data: [20, 5, 10, 3, 33, 1],
            lineStyle: {
              color: '#5470C6' //改变折线颜色
            },
          }
        ],
        grid: {
          x: 100,
          y: 50,
          x2: 10,
          y2: 50
        },
      };
      mapData({dictDataType:'issue_coke_yield',dictValue:this.name}).then((res)=>{
        // console.log(res.data)
        option['series'][0]['name'] = res.data.dataList[0]['yearName']
        option['series'][0]['data'] = res.data.dataList[0]['priceList']
        option['series'][1]['name'] = res.data.dataList[1]['yearName']
        option['series'][1]['data'] = res.data.dataList[1]['priceList']
        option['series'][2]['name'] = res.data.dataList[2]['yearName']
        option['series'][2]['data'] = res.data.dataList[2]['priceList']
        option['xAxis']['data'] = res.data.coordinate
        myChart.setOption(option);
      })

    }
  },
  mounted() {
    /**
     * 加载地图
     */
    this.drawChart();
  }
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;
.back{
  span {
    cursor: pointer;
  }
}
  .tabs {
    margin: 15px 0;

    div {
      display: inline-block;
      margin-right: 16px;
      padding:0 10px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    div:hover {
      background-color: #D3131A;
      color: #fff;
    }
  }

  .slot-span {
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 74px;
    height: 25px;
    background: #F2F2F2;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }

  .echarts {
    margin-top: 24px;
    width:1140px;
    height: 351px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
    padding:30px;
  }
}
</style>
